<template>
    <div>
        <div v-if="content.nodeType === 'paragraph'">
            <BlogContent v-for="(content2, index2) in content.content" 
                            :key="index2"
                            :content="content2" />            
        </div>
        <div>
            fafa
        </div>
    </div>
</template>

<script setup lang="ts">
import BlogContent from '@/components/BlogContent.vue'

type ContentNode = {
    nodeType: string;
    content?: ContentNode[];
}

defineProps<{
    content: ContentNode
}>()
</script>   
